import ManualPage from './ManualPage';

const Index = () => {
  return <ManualPage />;
};

export default Index;
